import {FormControl, FormGroup} from '@angular/forms';
import {BeneficiaryPreferencesFormModel} from './beneficiary-preferences-form.model';
import {NotyfikacjeBeneficjenta} from '../../../../../shared/models/notyfikacje-beneficjenta';

export class BeneficiaryPreferencesFormBuilder {
  public static createFormGroup(
    preferencjeBeneficjenta?: NotyfikacjeBeneficjenta,
  ): FormGroup<BeneficiaryPreferencesFormModel> {
    return new FormGroup<BeneficiaryPreferencesFormModel>({
      newDocument: new FormControl(
        preferencjeBeneficjenta?.nowyDokument || false,
      ),
      documentPickupDeadline: new FormControl(
        preferencjeBeneficjenta?.terminOdbioruDokumentu || false,
      ),
      documentPickupOverdue: new FormControl(
        preferencjeBeneficjenta?.dokumentPoTerminieOdbioru || false,
      ),
      applicationStatusChange: new FormControl(
        preferencjeBeneficjenta?.zmianaStatusuWniosku || false,
      ),
      electronicNotificationsConsent: new FormControl(
        preferencjeBeneficjenta?.zgodaNaPowiadomieniaElektroniczne || false,
      ),
      electronicNotificationsAnnouncementsConsent: new FormControl(
        preferencjeBeneficjenta?.zgodaNaPowiadomieniaElektroniczneKomunikat ||
          false,
      ),
      automaticDataUpdateConsent: new FormControl(
        preferencjeBeneficjenta?.zgodaNaAutomatyczneZapisywanieDanych || false,
      ),
    });
  }

  public static toModel(
    formGroup: FormGroup<BeneficiaryPreferencesFormModel>,
  ): NotyfikacjeBeneficjenta {
    const value = formGroup.value;
    return {
      nowyDokument: value.newDocument || false,
      terminOdbioruDokumentu: value.documentPickupDeadline || false,
      dokumentPoTerminieOdbioru: value.documentPickupOverdue || false,
      zmianaStatusuWniosku: value.applicationStatusChange || false,
      zgodaNaPowiadomieniaElektroniczne:
        value.electronicNotificationsConsent || false,
      zgodaNaPowiadomieniaElektroniczneKomunikat:
        value.electronicNotificationsAnnouncementsConsent || false,
      zgodaNaAutomatyczneZapisywanieDanych:
        value.automaticDataUpdateConsent || false,
    };
  }
}
